import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IUbicacionRequest } from "../../../Interfaces/auxiliar/IUbicacion";
import UbicacionService from "../../../services/auxiliar/UbicacionService";
import { Ifilter } from "../../../Interfaces/filter";

interface UbicacionProps {
    // nivel: number;
    isOpen: boolean;
    comboNivel: number
}

export const UseComboRegion = ({ comboNivel = 0, isOpen }: UbicacionProps) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterComboRegion, setFilterComboRegion] = useState<IUbicacionRequest>({
        skip: 0,
        take: 20,
        nivel: comboNivel,
        search:""
    });
    const [dataComboRegion, setDataComboRegion] = useState<IComboBoxOption[]>([]);

    const comboBoxRefRegion = useRef<IComboBox>(null);
    const onClickComboRegion= () => comboBoxRefRegion.current?.focus(true);

    const onChangeRegion= (value:any) => {
        setFilterComboRegion({ ...filterComboRegion, search: value });
    }
   
    const _onkeyUpSearchRegion = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefRegion.current?.focus(false);
            setFilterComboRegion({
                skip: 0,
                take: 20,
                nivel: comboNivel
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilterComboRegion({ ...filterComboRegion, search: value });
        }
    };

    const listarComboRegion = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        UbicacionService.ComboUbicacion(filterComboRegion).then((res) => {
            if (res.status === 200) {
                setDataComboRegion(res.data);
            }
        });
    };

    useEffect(() => {
        if (isOpen) {
            listarComboRegion();
        }
    }, [isOpen]);
    
    useEffect(()=>{
        if(filterComboRegion.search!=""){
            listarComboRegion()
        }
    },[filterComboRegion.search])

    return {
        dataComboRegion,
        onClickComboRegion,
        _onkeyUpSearchRegion,
        comboBoxRefRegion,
        filterComboRegion,
        setFilterComboRegion,
        onChangeRegion
    };
}

